"use client";
import React from "react";
import FilterPatientScript from "../../../global/view/filter-patient-scriptForm";
import styles from "../css/ClinicScriptPatientDetails.module.css";

export default function ClinicScriptPatientDetails() {
  // Custom table headers configuration
  const customTableHeaders = {
    scriptNo: "Clinic Reference",
    date: "Date Visited",
    consultationType: "Consultation Type",
    action: "Action"
  };

  // Columns to hide in the table
  const columnsToHide = [
    "drugs", 
    "repeat", 
    "total", 
    "paymentType", 
    "scriptStatus", 
    "followUp"
  ];

  // Add Consultation Type column
  const consultationTypeColumn = {
    header: "Consultation Type",
    accessor: "consultationType",
    render: (value, row) => value || "Clinic Consultation" // Default to "Clinic Consultation" if not specified
  };

  // Custom navigation resolver to handle beneficiary information
  const actionNavigateResolver = (row) => {
    // Extract beneficiary information from the row data if available
    const isBeneficiary = row.isBeneficiary || false;
    const patientId = row.patientId || row.patient?.patientId;
    const prescriptionId = row.prescriptionid || row.prescriptionId || row.scriptNo;
    
    return {
      pathname: `/customer/dispensary/clinic-script/details/${prescriptionId}`,
      state: {
        profileNo: row.profileNo,
        patientId: patientId,
        isBeneficiary: isBeneficiary,
        // Include additional beneficiary context
        mainMemberId: row.mainMemberId || null,
        clinicReference: row.clinicReference || row.clinicreference || null,
        patientType: isBeneficiary ? 'Beneficiary' : 'Main Member'
      }
    };
  };

  return (
    <div className={styles.content}>
      <FilterPatientScript
        hideNewScriptButton={true}
        hideMedicationHistoryButton={true}
        containerClassName={styles.filterContainer}
        filterRowClassName={styles.centerFilters}
        tableHeaders={customTableHeaders}
        columnsToHide={columnsToHide}
        extraColumns={[consultationTypeColumn]}
        actionNavigatePath="/customer/dispensary/clinic-script/details"
        actionNavigateResolver={actionNavigateResolver}
        hideOtc={true} // Hide OTC scripts
        clinicOnly={true} // Custom prop to filter only clinic scripts
      />
    </div>
  );
}
